import { useInfiniteQuery } from '@tanstack/react-query';

import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { getNextPageParam } from '@/modules/pagination/getNextPageParam';
import { buildShopSearchQueryParams } from '@/modules/search/helpers';
import { useSearchFilters } from '@/modules/search/useSearchFilters';
import { useSearchInput } from '@/modules/search/useSearchInput';
import { fetchShopProducts } from '@/modules/shop/api';
import { useFilteredProductsQueryKey } from '@/modules/shop/hooks/useFilteredProductsQueryKey';

export function useFilteredShopProducts(sellerId?: number) {
  const { searchInput } = useSearchInput();
  const { searchFilters } = useSearchFilters();
  const { location } = useCurrentLocation();
  const queryKey = useFilteredProductsQueryKey(sellerId);

  return useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchShopProducts(
        sellerId as number,
        buildShopSearchQueryParams({
          location,
          searchInput,
          searchFilters,
          after: pageParam,
        })
      ),
    initialPageParam: undefined,
    getNextPageParam,
    enabled: Boolean(sellerId),
  });
}
